import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BoxTableTile from './box-table-tile';

import styles from './boxTable.module.less';

const BoxTable = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <BoxTableTile {...tile} key={id} />
  ));

  return <div className={styles.boxTableContainer}>{renderedTiles}</div>;
};

BoxTable.displayName = 'Box Table';

BoxTable.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(BoxTable.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default BoxTable;
